import React, { useState, useEffect, useRef } from 'react';
import Tag from '../../components/ui/Tag';
import ElixirImage from '../../../public/images/CRESSON-HONEY.webp';
import Button from '@/components/ui/Button';
import { useCart } from '../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

const PartnersSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);
  const [imgVisible, setImgVisible] = useState(false);
  const sectionRef = useRef(null);
  const { addToCart } = useCart();
  const navigate = useNavigate();

  // Fetch first product from API
  const [featuredProduct, setFeaturedProduct] = useState(null);
  const [variantIndex, setVariantIndex] = useState(0);
  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_BASE_URL}/api/products`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setFeaturedProduct(data[0]);
        }
      });
  }, []);

  const handleAddToCart = () => {
    if (featuredProduct && featuredProduct.variants && featuredProduct.variants[variantIndex]) {
      const variant = featuredProduct.variants[variantIndex];
      if (variant.stock > 0) {
        addToCart({
          id: featuredProduct._id || featuredProduct.id,
          title: featuredProduct.name,
          image: featuredProduct.image,
          description: featuredProduct.description,
          price: variant.price,
          weight: variant.weight,
          variantIndex,
          stock: variant.stock,
          quantity: 1,
        });
      } else {
        navigate(`/notify-me?productId=${featuredProduct._id || featuredProduct.id}`);
      }
    }
  };

  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Section is in view
          }
        });
      },
      {
        threshold: 0.3, // 50% of the section must be in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current); // Observe the section
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Trigger individual animations after section is visible
  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
      setTimeout(() => setParaVisible(true), 300); // Delay para animation
      setTimeout(() => setImgVisible(true), 600); // Delay image animation
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-12">
          <h2
            className={`text-2xl md:text-4xl lg:text-4xl font-extralight text-[#000000] mb-6 text-center mt-10 md:text-center transition-all duration-1000 ${
              titleVisible
                ? 'opacity-100 translate-y-0 animate-slideUp'
                : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Experience the Taste of the Mediterranean
          </h2>
          {/*           <p
            className={`md:text-xl text-[#666] max-w-4xl mx-auto px-8 text-center md:text-center transition-all duration-1000 ${
              paraVisible ? 'opacity-100 translate-y-0 animate-slideUp' : 'opacity-0 translate-y-10'
            }`}
          >
            Elixir stands apart from ordinary honey. We offer:
          </p> */}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-8">
          {/* Image */}
          <div
            className={`w-full  md:w-1/2 transition-all duration-1000 ${
              imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <img
              src={featuredProduct?.image || ElixirImage}
              alt={featuredProduct?.name || 'Elixir Eucalyptus'}
              className="rounded-lg h-auto w-full max-w-md md:max-w-lg lg:max-w-xl mx-auto"
            />
          </div>
          {/* Text Content */}
          <div className="w-full md:w-1/2 text-left px-4 md:px-0">
            <h2
              className={`text-2xl md:text-2xl lg:text-2xl font-extralight text-[#000000] mb-6`}
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {featuredProduct?.name || 'Loading...'}
            </h2>
            <ul className="space-y-4 text-lg text-[#333]">
              <li>
                {featuredProduct?.description || '...'}
              </li>
            </ul>
            {/* Variant Selector */}
            {featuredProduct?.variants && featuredProduct.variants.length > 0 && (
              <div className="my-4">
                {/* <label htmlFor="variant-select" className="block text-sm font-medium text-gray-700 mb-1">Weight:</label> */}
                <select
                  id="variant-select"
                  className="border rounded px-3 py-2"
                  value={variantIndex}
                  onChange={e => setVariantIndex(Number(e.target.value))}
                >
                  {featuredProduct.variants.map((variant, idx) => (
                    <option key={variant._id || idx} value={idx}>
                      {variant.weight}g {/* - {variant.price} € */}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* Price and Stock */}
           {/*  {featuredProduct?.variants && featuredProduct.variants[variantIndex] && (
              <div className="mb-2 text-base font-semibold">
                <span className="text-yellow-700">{featuredProduct.variants[variantIndex].price} TND</span>
                {featuredProduct.variants[variantIndex].stock > 0 ? (
                  <span className="ml-4 text-green-700">In stock: {featuredProduct.variants[variantIndex].stock}</span>
                ) : (
                  <span className="ml-4 text-red-600">Out of stock</span>
                )}
              </div>
            )} */}
            {/* Add to Cart or Notify Me */}
            {featuredProduct?.variants && featuredProduct.variants[variantIndex] && featuredProduct.variants[variantIndex].stock > 0 ? (
              <Button
                variant="gold"
                size="large"
                onClick={handleAddToCart}
                className="font-semibold rounded-3xl py-3 my-6 px-5"
                disabled={!featuredProduct}
              >
                Add to cart
              </Button>
            ) : (
              <Button
                variant="gold-outline"
                size="large"
                onClick={() => navigate(`/notify-me?productId=${featuredProduct?._id || featuredProduct?.id}`)}
                className="font-semibold rounded-3xl py-3 my-6 px-5"
                disabled={!featuredProduct}
              >
                Notify Me
              </Button>
            )}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-16 px-4 sm:px-6 md:px-12">
          {/* Text Block 1 */}
          <div className="w-full md:w-1/2 text-left">
            <h2
              className="text-xl sm:text-2xl font-extralight text-[#000000] mb-4 sm:mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              The Mediterranean Heart
            </h2>
            <ul className="space-y-4 text-base sm:text-lg text-[#333]">
              <li>
                Tunisia, a land of ancient civilizations and breathtaking landscapes, is the cradle
                of Elixir. Here, beekeeping is not just a practice, but a heritage passed down
                through generations. Our honey is a testament to this deep connection between
                people, nature, and time.
              </li>
            </ul>
          </div>

          {/* Text Block 2 */}
          <div className="w-full md:w-1/2 text-left">
            <h2
              className="text-xl sm:text-2xl font-extralight text-[#000000] mb-4 sm:mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              A Symphony of Flavors, Crafted by Nature
            </h2>
            <ul className="space-y-4 text-base sm:text-lg text-[#333]">
              <li>
                The unique flora of Tunisia, from the wild thyme of the mountains to the fragrant
                eucalyptus forests, gives Elixir its distinctive character. Each variety captures
                the essence of its source, offering a sensory journey through the Mediterranean.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
